import { Component } from '@angular/core'

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrl: './root.component.sass',
  standalone: false,
})
export class RootComponent {
}
